import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-05/lesson-18/task-04";

const task: Slide = {
  titleHtml:
    "If you want to ensure the comfort in two adjacent rooms by mutually protecting them from the usual<br>living noise (dominantly middle- and high-frequency noise) coming from one room to the other,<br>which wall construction between them will you choose?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
